
export default function NumberOnlyInputModule(element) {
    element.addEventListener('keyup', function(event) {
        let value = element.value.replace(/[^\0-9+]/ig, '');

        value = value.replace(/\s/, '');

        element.value = value;
    });

    return this;    
}

window.modules = window.modules || {}
window.modules.NumberOnlyInputModule = NumberOnlyInputModule;
